/**
 * 記事・タグのクリックをAPIに送信するユーティリティ。
 * 失敗してもUIを止めないよう、例外は握りつぶします。
 */

type IdLike = number | string | bigint;

function normalizeId(value: IdLike): string {
	if (typeof value === "bigint") return value.toString();
	if (typeof value === "number") return Number.isInteger(value) ? String(value) : "";
	if (typeof value === "string") return value.trim();
	return "";
}

async function postJson(endpoint: string, payload: Record<string, unknown>) {
	if (!window.SiteAnalytics?.allowed) return;
	try {
		await fetch(endpoint, {
			method: "POST",
			headers: { "Content-Type": "application/json", "X-Analytics-Consent": window.SiteAnalytics.consent },
			body: JSON.stringify(payload),
			keepalive: true,
		});
	} catch (error) {
		// ログだけ残して処理を止めない
		console.error("click log failed", endpoint, error);
	}
}

export async function logArticleClick(articleId: IdLike) {
	const id = normalizeId(articleId);
	if (!id) return;
	await postJson("/api/click/article", { articleId: id });
}

export async function logTagClick(tagId: IdLike) {
	const id = normalizeId(tagId);
	if (!id) return;
	await postJson("/api/click/tag", { tagId: id });
}
